import React from 'react'
import Card from 'react-bootstrap/Card';
import './Carousel_cult.css'
import img from './photos/sld1.jpeg'
import img1 from './photos/sld2.jpeg'
import img2 from './photos/sld3.jpeg'
import img3 from './photos/sld4.jpg'

function Carousel_cult() {
  return (
    <div className='carousel_div'>
       <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img}/>
        <h1>PAINTINGS</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img1}/>
        <h1>SKETCHING</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img2}/>
        <h1>MURALS</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img3}/>
        <h1>NEW MEDIA</h1>
      </Card.Body>
    </Card>
    </div>
  )
}

export default Carousel_cult
